/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  app: number;
  date: string;
  destination: number;
  days: number;
  uu: number;
};

export type IndexParams = {
  appId: number;
  startAt: string;
  endAt: string;
};

export class Api {
  public static index(developerId: number, params: IndexParams) {
    return request.get<IndexResponse[]>(
      `/developers/${developerId}/retention_reports`,
      params
    );
  }
}
